import { useEffect, useState } from 'react'
import { Header, Table, Pagination, Groupper, Button, Icon } from 'react-frontier2'
import { ErrorHeader, SearchPDVModal } from '../../components'
import { Link, useNavigate } from 'react-router-dom'
import { addCommas, bindClick, fromUnixLocal } from '@arema/components/Util'
import { useTitle } from '@arema/components/Hooks'
import { PDV } from '../../AdminClasses'
import { useTranslation } from 'react-i18next'
import API from '../../API'

interface PdvConcilia {
	pdv_id: number,
	pdv_name: string,
	date_activity: number,
	money_supervised: boolean,
	total_cash: number,
	deposit: number,
}

const PAGE_SIZE = 30;
function PdvCorteList(){
	var navigate = useNavigate();
	var { t } = useTranslation();
	var { setTitle } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [pdvConcilia, setPdvConcilia] = useState<PdvConcilia[]>(null);
	var [page, setPage] = useState<number>(0);
	var [searchModal, setSearchModal] = useState<boolean>(false);
	var [showAll, setShowAll] = useState<boolean>(false);

	useEffect(()=>{
		loadData(false, page);
		setTitle('Conciliación Taquillas');
	}, [])

	var changeShowAll = ()=>{
		setPdvConcilia(null);
		setShowAll(!showAll);
		setPage(0);
		loadData(!showAll, 0);
	}

	var loadData = (show_all: boolean, page?: number)=>{
		API.getPdvConciliaList(null, show_all, page * PAGE_SIZE, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPdvConcilia(res.data);
		}).catch(err=>{
			setLoadError('Error inesperado cargando los puntos (LCL-1)');
		})
	}

	var onPageChange = (page: number)=>{
		setPage(page);
		loadData(showAll, page)
	}

	var onPdvSelected = (pdv: PDV)=>{
		navigate(`/taquillas/${pdv.pdv_id}`);
	}

	var hasNext = !!pdvConcilia && pdvConcilia?.length >= PAGE_SIZE;
	return <>
		<Groupper fitted
			title={'Taquillas'}
			titleRight={(
				<Button text='Buscar' iconName='search' color='black' onClick={bindClick(setSearchModal, true)} />
			)}
			style={{ maxWidth: 700, margin: 'auto' }}
		>
			<Groupper.Divider style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 10, borderTop: 0, marginBottom: 0 }} >
				<div style={{ fontSize: 14, fontWeight: 'normal', color: 'gray', textTransform: 'none' }}>
					Mostrando solo PDV con supervisión de efectivo
				</div>
				<Button text='Opciones' size='tiny' iconName={'wrench'} menu={[
					{ text: 'Mostrar todos', iconName: showAll ? 'circle-check' : 'circle', iconSolid: !!showAll, value: -2, onClick: changeShowAll },
					{ text: 'Exportar', iconName: 'file-csv', value: -3 }
				]} />
			</Groupper.Divider>
			<Table fitted>
				<Table.Head data={[['ID', 'PDV', 'Actividad', 'Supervisa', 'Efectivo']]} collapsingIndexes={[0, 2, 3, 4]} />
				<Table.Body>
					{(!pdvConcilia || loadError) ? (
						<Table.Cell colSpan={100}>
							<Header text={loadError ? t('common.error') : t('common.loading')} loading={!loadError} style={{ marginTop: 20, marginBottom: 20, padding: 0, }} />
						</Table.Cell>
					) : pdvConcilia.length===0 ? (
						<Table.Cell row empty colSpan={100} value={'No hay PDVs'} />
					) : pdvConcilia.map(p=>(
						<Table.Row selectable compact
							as={Link}
							key={`PVRW-${p.pdv_id}`}
							to={`/taquillas/${p.pdv_id}`}
							collapsingIndexes={[0, 2, 3, 4]}
							centeredIndexes={[2, 3]}
							data={[
								p.pdv_id, 
								p.pdv_name, 
								p.date_activity ? (
									fromUnixLocal(p.date_activity).toFormat('dd/MMM/yy HH:mm')
								) : (
									<Icon name='minus' color='gray' />
								), 
								<Icon name={p.money_supervised ? 'circle-check' : 'minus'} />,
								<span style={{
									color: (p.total_cash-p.deposit)>0 ? 'black' : 'gray',
									fontWeight: (p.total_cash-p.deposit)>0 ? 'bold' : 'normal'
								}}>
									${addCommas(p.total_cash-p.deposit)}
								</span>
							]} 
						/> 
					))}
				</Table.Body>
				<Table.Footer actions={(
					<Pagination inline page={page} onPageChange={onPageChange} hasNext={hasNext} />
				)} />
			</Table>
		</Groupper>
		<SearchPDVModal open={searchModal} onClose={bindClick(setSearchModal)} onSelected={onPdvSelected} />
	</>
}

export default PdvCorteList;